import * as React from 'react';
import WizardCard from '../../components/WizardCard/WizardCard';
import { serviceTypes } from './ServiceTypeStaticData';
import { withRouter } from 'react-router';
import withContainer from '../../containers/WithContainer';
import { ContainerNew } from '../../containers/AppContainer';
import Switch from 'react-switch';
import { StepNames } from '../../types/stepNames';

interface ServiceTypeProps {
  appContainer: ContainerNew;
}
const ServiceType: React.FunctionComponent<ServiceTypeProps> = (
  props: ServiceTypeProps
) => {
  const { appContainer } = props;
  const { state } = appContainer;
  return (
    <WizardCard
      title="How would you like to offer your services?"
      isDisabled={!state.provider.offersHome && !state.provider.offersMobile}
      onNext={async () => {
        await appContainer.updateProvider({
          hair_cutting: {
            offers_home: state.provider.offersHome,
            offers_mobile: state.provider.offersMobile,
          },
          mobile: appContainer.getUserMobile(),
          onboarding_step: appContainer.stepsMapping.indexOf(
            StepNames.serivceTypes
          ),
        });
      }}
    >
      <div className="has-margin-top-35">
        <div className="columns is-multiline is-capitalized">
          {serviceTypes.map(({ label, value }) => (
            <div className="column is-full has-cursor-pointer" key={value}>
              <div
                className="columns is-multiline is-mobile"
                onClick={() => appContainer.handleProviderServiceType(value)}
              >
                <div className="column is-9-mobile">
                  <div>{label}</div>
                </div>
                <div className="column is-3-mobile">
                  <div>
                    <Switch
                      height={24}
                      width={45}
                      onColor="#00d1b2"
                      checkedIcon={false}
                      uncheckedIcon={false}
                      checked={state.provider[value] || false}
                      onChange={() =>
                        appContainer.handleProviderServiceType(value)
                      }
                    />
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </WizardCard>
  );
};
export default withRouter(withContainer(ServiceType));
